import { FC, HTMLAttributes } from 'react';

import classes from './Divider.module.scss';

type DividerProps = HTMLAttributes<HTMLDivElement>;

const Divider: FC<DividerProps> = ({ className, ...props }) => {
  return (
    <div className={`${classes.divider} ${className}`} {...props}>
      <span>
        <hr className={classes.dividerLine} />
      </span>
    </div>
  );
};

export default Divider;
